import { IRight } from 'src/app/services/auth';

export const prepareData = (assignments: IRight[]) => {
    return assignments.map((assignment) => {
        const updatedAssignment = { ...assignment, name: undefined };
        return updatedAssignment;
    });
};
